import React from 'react'
import { get, map, findIndex } from 'lodash'

import { __ } from '~/i18n'

import Steps from '~/components/steps';
import {STATE_ORDERED, STATE_SUMMARY} from "~/constants/cart";

const getBreadcrumbLabel = (key) => {
  const labels = {
    'contents': __('Cart'),
    'contact': __('Customer Information'),
    'delivery': __('Shipping Information'),
    'payment': __('Payment Information'),
    'summary': __('Summary')
  };

  return get(labels, key, key);
};

export default class CheckoutSteps extends React.PureComponent {
  render() {
    const { currentStep, steps, availableSteps, onNavigate, retrying, error } = this.props;

    const activeIndex = findIndex(steps, (step) => (step.to === currentStep));
    const items = map(steps, (route, index) => {
      const { to, name } = route;
      const isCompleted = availableSteps.indexOf(to) > -1;
      const label = getBreadcrumbLabel(to);

      let stepOverrides = {};

      if(currentStep === STATE_ORDERED) {
        stepOverrides.status = 'finish';

        if(retrying && to === STATE_SUMMARY) {
          stepOverrides.status = 'error';
        }
      }

      if(error && activeIndex === index) {
        stepOverrides.status = 'error';
      }
      return (
        <Steps.Step
          key={ to }
          title={ label }
          onClick={ (e) => {
            if(isCompleted) {
              onNavigate(to, name)
            }
          } }
          {...stepOverrides}
        />
      )
    });

    return (
      <Steps progressDot current={ activeIndex } >
        { items }
      </Steps>
    )
  }
}